import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "C肝報告",
    isNumber: true,
  },
];

export const CheckAreaToHepatitisC = {
  label: "篩檢場域 VS C肝",
  key: "CheckAreaToHepatitisC",
  path: "HepatitisTracking/CheckAreaToHepatitisC",
  api: "TCS_V_LiverS021",
  render: (options) => (
    <Diagram.HepatitisTracking.CheckAreaToHepatitisC {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "篩檢場域",
      field: "篩檢場域",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
